import { emitter } from "@liquidweb-dev/lw-chat-js";
import { onMounted } from "vue";
import { openChat } from "@/utils/chat";
import { ref } from "vue";
import router from "@/router";
import store from "@/store";
import { useChat } from "@/utils/chat";

export const chatEyeCatcherMixin = {
  emits: ["change"],
  props: {
    department: String,
  },
};

export const chatEyeCatcherSetup = (props, { emit }) => {
  const { chatInviteVisible, isInvitedToChat, showChatInvite, startIdleChatInvite } = useChat();
  const loading = ref(false);
  const chatting = ref(false);
  const chat = () => {
    loading.value = true;
    const matchedRoutes = [...router.currentRoute.value.matched];
    const isCheckout = matchedRoutes.reverse().find((route) => !!route.meta.isCheckout);
    const isStoreBuilder = isCheckout && store.getters["surveys/requireSurvey"];
    const preselectDepartment = isStoreBuilder
      ? store.getters["surveys/getSurveyType"]
      : props.department;

    openChat({ preselectDepartment })
      .then(() => {
        chatInviteVisible.value = false;
        chatting.value = true;
        emitter.on("afterDestroy", () => {
          chatting.value = false;
          emit("change", chatting.value);
        });
        emit("change", chatting.value);
      })
      .finally(() => {
        loading.value = false;
      });
  };

  onMounted(() => {
    startIdleChatInvite();
  });

  return {
    loading,
    chatting,
    chat,
    chatInviteVisible,
    isInvitedToChat,
    showChatInvite,
  };
};

export const chatInviteSetup = (props, { emit }) => {
  const loading = ref(false);

  const chat = () => {
    store.dispatch("analytics/send", {
      name: "structured",
      data: {
        category: "chat",
        action: "checkoutChatInvitation_accepted",
      },
    });
    loading.value = true;
    openChat({ isInvitation: true, preselectDepartment: "Sales" })
      .then(() => {
        emit("close");
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const close = () => {
    emit("close");
  };

  return { chat, loading, close };
};
